var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-footer"},[_vm._v("\n\tCopyright 2018 Vue.js Korea. All rights reserved.\n  ")])}
var staticRenderFns = []

export { render, staticRenderFns }